const packageSettingsStored = JSON.parse(
  localStorage.getItem("packageSettingsStored") as string
);
const initialState = packageSettingsStored
  ? { packageSettings: packageSettingsStored }
  : { packageSettings: {} };

export const packageSettings = {
  namespaced: true,
  state: initialState,
  actions: {
    setPackageSettings(
      { commit }: any,
      current: { settings: any; index: any }
    ) {
      commit("setPackageSettings", current);
      localStorage.setItem(
        "packageSettingsStored",
        JSON.stringify(this.state.packageSettings.packageSettings)
      );
    },
  },
  mutations: {
    setPackageSettings(state: any, current: any) {
      state.packageSettings[current.index] = current.settings;
    },
  },
};
